module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0067.jpg?v=526c5289";